"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Loading = void 0;
var _react = _interopRequireDefault(require("react"));
var Loading = exports.Loading = function Loading() {
  return /*#__PURE__*/_react["default"].createElement("div", {
    "data-testid": "loader-component"
  }, "Loading ...");
};